const { ListPartsCommand } = require('@aws-sdk/client-s3');
const { VALIDATION_RESULT } = require('../constants');
const logger = require('../../logger');

/**
 * 验证 UploadId 是否有效
 * @param {S3Client} s3Client
 * @param {string} bucket
 * @param {string} key
 * @param {string} uploadId
 * @param {AbortSignal} abortSignal - 可选的取消信号
 * @returns {Promise<string>} 返回 VALIDATION_RESULT 中的值
 */
async function validateUploadId(s3Client, bucket, key, uploadId, abortSignal = null) {
    // 基础参数验证
    if (!uploadId || !bucket || !key || !s3Client) {
        logger.info('[AWS Multipart] Invalid parameters for uploadId validation');
        return VALIDATION_RESULT.INVALID;
    }

    // uploadId 格式验证（AWS uploadId 通常是特定格式）
    if (typeof uploadId !== 'string' || uploadId.length < 10) {
        logger.info('[AWS Multipart] Invalid uploadId format');
        return VALIDATION_RESULT.INVALID;
    }

    try {
        logger.info('[AWS Multipart] Validating uploadId on S3:', {
            bucket,
            key,
            uploadId,
        });

        const command = new ListPartsCommand({
            Bucket: bucket,
            Key: key,
            UploadId: uploadId,
            MaxParts: 1, // 只需要检查是否存在，不需要获取所有分片
        });

        const sendOptions = abortSignal ? { abortSignal } : {};
        const response = await s3Client.send(command, sendOptions);

        logger.info('[AWS Multipart] UploadId validation successful:', {
            uploadId,
            partsCount: response.Parts?.length || 0,
        });

        return VALIDATION_RESULT.VALID; // 明确返回 VALID
    } catch (error) {
        logger.info('[AWS Multipart] UploadId validation failed:', {
            uploadId,
            errorName: error.name,
            errorMessage: error.message,
        });

        // 明确的无效情况 - 应该清除缓存
        if (error.name === 'NoSuchUpload' || error.name === 'InvalidRequest') {
            return VALIDATION_RESULT.INVALID;
        }

        // 临时性问题 - 不应该清除缓存
        if (
            error.name === 'NetworkingError' ||
            error.name === 'TimeoutError' ||
            error.name === 'ServiceUnavailable' ||
            error.name === 'ThrottlingException' ||
            error.name === 'TooManyRequestsException' ||
            error.name === 'InternalError' ||
            error.name === 'AccessDenied'
        ) {
            // 可能是临时的权限问题
            return VALIDATION_RESULT.UNKNOWN;
        }

        // 其他未知错误，保守处理 - 不清除缓存
        return VALIDATION_RESULT.UNKNOWN;
    }
}

module.exports = {
    validateUploadId,
};
